import { ForgotEmailPopup, SignInForm } from '@src/features/user/auth';
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '@hooks/useAuth.ts';

export const SignInPage = () => {
  const [openForgotEmail, setOpenForgotEmail] = useState(false);

  const navigate = useNavigate();
  const { signIn } = useAuth();

  return (
    <React.Fragment>
      <SignInForm
        onOpenForgotEmail={() => setOpenForgotEmail(true)}
        onOpenForgotPassword={() => navigate('/forgot-password')}
        onSubmit={signIn}
      />
      <ForgotEmailPopup
        open={openForgotEmail}
        onOpenChange={(val) => setOpenForgotEmail(val)}
      />
    </React.Fragment>
  );
};
